var pic1 = require('../../assets/images/facility/sports/pic1.jpg');
var pic2 = require('../../assets/images/facility/sports/pic2.jpg');
var pic3 = require('../../assets/images/facility/sports/pic3.jpg');
var pic4 = require('../../assets/images/facility/sports/pic4.jpg');
var pic5 = require('../../assets/images/facility/sports/pic2.jpg');
const DataGalleryFacilitySports = [
 {    
	id: 1,
	title:"Sports",
    image: pic1,	    
	alt  :"Sports",
  },
  {    
	id: 2,
	title:"Sports",
    image: pic2,	    
	alt: "Sports",
  },
  {    
	id: 3,
	title:"Sports",
    image: pic3,	    
	alt: "Sports",
  },
  {    
	id: 4,
	title:"Sports",
    image: pic4,	    
	alt: "Sports",
  },
  {    
	id: 5,
	title:"Sports",
    image: pic5,	    
	alt: "Sports",
  },
];
export default DataGalleryFacilitySports;